import { useEffect } from 'react';
import { atom, useAtomValue, useSetAtom } from 'jotai';

const sprdConsentAtom = atom<{
  // Don't use `active`. It is not reliable and can be true even if the user has not given consent. Use the other fields instead.
  active: boolean;
  consentId?: string;
  functional?: boolean;
  necessary?: boolean;
  performance?: boolean;
  remarketing?: boolean;
  social?: boolean;
} | null>(null);

export const useSprdConsentListener = () => {
  const setSprdConsent = useSetAtom(sprdConsentAtom);

  useEffect(() => {
    window.consentGiven = () => {
      try {
        setSprdConsent(window.sprdConsent?.getStatus() ?? null);
      } catch {}
    };

    if (window.sprdConsent?.getStatus) {
      try {
        setSprdConsent(window.sprdConsent.getStatus());
      } catch {}
    }
  }, [setSprdConsent]);
};

export const useSprdConsent = () => useAtomValue(sprdConsentAtom);
